import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ButtonIcon from "../../../../button";
import { CustomDropdown } from "../../../../common/custom-form/custom-dropdown.component";
import ManageLayout from "../../../../common/report/details/manage-report.component";
import AccountAuditRules from "../details/account-audit.rules.component";
import { AccountCostAllocation } from "../details/account-cost-allocation.component";
import { DetailsInfo } from "../details/account-details-info.component";
import AccountLocationAddress from "../details/account-location-details.componet";
import AccountLocationRemit from "../details/account-location-remit.component";
import { AccountPurchaseOrder } from "../details/account-purchase.component";
import { Selected_Index } from "../../../../../constants/internal-constants";
import { DetailList } from "../details-list/details-list.component";
export class AddAccountModal extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
      selected:[],
      CheckBoxValue:[
        "Fist Bill",
        "MRC Mismatch",
        "Invoice Total Mismatch",
        "Billing Start Date",
        "NRC Mismatch",
        "Invoice Percent",
        "Billing End Date",
        "Billing Account Mismatch",
        "Previous Balance",
        "High Spender",
        "Different Provider",
        "Previous Balance Percent",
        "Circuit Percent",
        "Disconnected",
        "Duplicate",
        "Order In Progress",
        "Deleted",
        "Unbilled Circuit",
        "Dispute In Process",
        "Circuit Not Found"
      ],
      dataTable:[
        {              
            HeaderItem:[
                {
                    name:"Contract Name"
                },
                {
                    name:"Vendor"
                }, {
                    name:"Status"
                }
            ],
            dataItem:[{            
                columnItem1:"3G Hutchison (GB) Contract",
                columnItem2: "3G Hutchison (GB)",
                columnItem3: "Expired"                       
            }, {            
                columnItem1:"3G Hutchison (GB) Contract",
                columnItem2: "3G Hutchison (GB)",
                columnItem3: "Expired"
            },{            
                columnItem1:"3G Hutchison (GB) Contract",
                columnItem2: "3G Hutchison (GB)",
                columnItem3: "Expired"
            }        
            ]

        }
    ],
      options:[
        { value: 'one', label: 'Option One' },
        { value: 'two', label: 'Option Two' },
    ],
      selectedTwo:[],
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }

  getDataSelected(data) {
    this.setState({selectedIndex:data})
  }
 

  render(){
    const {show,selected,clearData }=this.state;
    return(
      <>

      <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="file-plus" iconSize="17px" customClassName="header-filter-button" labelName={this.props.labelName}/>
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container finance-modal-container finance-detail-table "
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="manage-order-table finance-detail-table" >    
                <div className="manage-order-container">
                        <DetailsInfo customClass="manage-order-detail"/>
                    </div>
                    <div className="horizontal-separator"></div>
                    <div>  
                        <DetailList/>
                    </div>                               
            </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose.bind(this)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>alert("Click Me")}>SAVE</Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
